module.exports = {
  PRODUCTION_HOSTNAME: 'corporatebroking.abnamro.com',
  DEMO_HOSTNAME: 'cbp-st02.eu-gb.mybluemix.net'
};